exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".share-popover-content-container{min-width:520px;max-width:600px}.share-popover-content{min-height:180px;margin:0 10px}.share-popover-content>div{margin-bottom:20px}", ""]);

// exports
